export default __webpack_public_path__ + "assets/90f9c501b29b952e98d53ad3594951ee.svg";